module.exports = __webpack_public_path__ + "img/empty.84e4e27e.svg";